<template>
<div class="notebook__list">
    <h4>Consignas transitorias</h4>
    <div class="table-responsive">
        <table class="table table-condensed table-bordered table-small table-hover">
            <thead class="thead-orange">
                <tr>
                    <th>Fecha</th>
                    <th>Autor</th>
                    <th>Responsable</th>
                    <th>Anotación</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="note in transitories" :key="note.id">
                    <!-- <tr v-if="!!transitories.length && !!note.assignee && note.assignee.id === user.id ? true: false" v-for="note in transitories"> -->
                    <td>{{ note.created_at | datetime }}</td>
                    <td>{{ note.user.name }}</td>
                    <td>{{ note.assignee ? note.assignee.name: '' }}</td>
                    <td>{{ note.content }} </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>
<script> 
    import { mapGetters } from 'vuex';
    import notebookRepository from '../../../repositories/notebook.repository';
    import PopUp from '../../UI/Controls/PopUp/PopUp.vue';

    export default {
        components: {
            appPopUp: PopUp
        },
        data(){
            return{
                transitories: []
            }
        },
        methods: {
            loadTransitories(){
                 const nr = Object.assign({}, notebookRepository);
                nr.getTransitories(this.client.id)
                .then(data => {
                    this.transitories = data.notes;
                })
                .catch(error => toastr.error('Ocurrió un error al cargar las estructuras'));
            }
        },
        created(){
            this.loadTransitories();

        }
    }
</script>